import CustomField from "../../../model/customField/CustomField";

/**
 * Fetch job custom fields successful action.
 */
export const JOB_CUSTOM_FIELDS_FETCHED = "JOB_CUSTOM_FIELDS_FETCHED";
export type JOB_CUSTOM_FIELDS_FETCHED = { fields: Array<CustomField> }

/**
 * Fetch lead custom fields successful action.
 */
export const LEAD_CUSTOM_FIELDS_FETCHED = "LEAD_CUSTOM_FIELDS_FETCHED";
export type LEAD_CUSTOM_FIELDS_FETCHED = { fields: Array<CustomField> }

export const PARTNER_BRAND_CUSTOM_FIELDS_FETCHED = "PARTNER_BRAND_CUSTOM_FIELDS_FETCHED";
export type PARTNER_BRAND_CUSTOM_FIELDS_FETCHED = { fields: Array<CustomField> }

export const JOB_CUSTOM_FIELD_CREATED = "JOB_CUSTOM_FIELD_CREATED";
export type JOB_CUSTOM_FIELD_CREATED = { field: CustomField }

export const LEAD_CUSTOM_FIELD_CREATED = "LEAD_CUSTOM_FIELD_CREATED";
export type LEAD_CUSTOM_FIELD_CREATED = { field: CustomField }

export const PARTNER_BRAND_CUSTOM_FIELD_CREATED = "PARTNER_BRAND_CUSTOM_FIELD_CREATED";
export type PARTNER_BRAND_CUSTOM_FIELD_CREATED = { field: CustomField }

export const JOB_CUSTOM_FIELD_UPDATED = "JOB_CUSTOM_FIELD_UPDATED";
export type JOB_CUSTOM_FIELD_UPDATED = { field: CustomField }

export const LEAD_CUSTOM_FIELD_UPDATED = "LEAD_CUSTOM_FIELD_UPDATED";
export type LEAD_CUSTOM_FIELD_UPDATED = { field: CustomField }

export const PARTNER_BRAND_CUSTOM_FIELD_UPDATED = "PARTNER_BRAND_CUSTOM_FIELD_UPDATED";
export type PARTNER_BRAND_CUSTOM_FIELD_UPDATED = { field: CustomField }